import type { Interview } from "@aglocal/schema/Interview";

const EXCLUDED_TITLES = new Set(["unknown", "n/a", "null", ""]);

export default function getJobTitle(interview: Interview): string | null {
  const title = interview.interviewee?.connectedDetails?.jobTitle?.trim() ?? "";
  return EXCLUDED_TITLES.has(title.toLowerCase()) ? null : title;
}
